import FormatItalicIcon from "@mui/icons-material/FormatItalic";
import { SvgIconProps, useTheme } from "@mui/material";

export const ItalicIcon: React.FC<SvgIconProps> = (props) => {
  const theme = useTheme();

  return (
    <FormatItalicIcon {...props} style={{ color: theme.palette.brandedTypography.textColor }} />
  );
};

export default ItalicIcon;
